/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponsePaging } from './ListOperations200ResponsePaging';
import {
    ListOperations200ResponsePagingFromJSON,
    ListOperations200ResponsePagingFromJSONTyped,
    ListOperations200ResponsePagingToJSON,
    ListOperations200ResponsePagingToJSONTyped,
} from './ListOperations200ResponsePaging';
import type { ListDetails200ResponseItemsInner } from './ListDetails200ResponseItemsInner';
import {
    ListDetails200ResponseItemsInnerFromJSON,
    ListDetails200ResponseItemsInnerFromJSONTyped,
    ListDetails200ResponseItemsInnerToJSON,
    ListDetails200ResponseItemsInnerToJSONTyped,
} from './ListDetails200ResponseItemsInner';

/**
 * 
 * @export
 * @interface ListDetails200Response
 */
export interface ListDetails200Response {
    /**
     * 
     * @type {Array<ListDetails200ResponseItemsInner>}
     * @memberof ListDetails200Response
     */
    items?: Array<ListDetails200ResponseItemsInner>;
    /**
     * 
     * @type {ListOperations200ResponsePaging}
     * @memberof ListDetails200Response
     */
    paging?: ListOperations200ResponsePaging;
}

/**
 * Check if a given object implements the ListDetails200Response interface.
 */
export function instanceOfListDetails200Response(value: object): value is ListDetails200Response {
    return true;
}

export function ListDetails200ResponseFromJSON(json: any): ListDetails200Response {
    return ListDetails200ResponseFromJSONTyped(json, false);
}

export function ListDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDetails200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ListDetails200ResponseItemsInnerFromJSON)),
        'paging': json['paging'] == null ? undefined : ListOperations200ResponsePagingFromJSON(json['paging']),
    };
}

export function ListDetails200ResponseToJSON(json: any): ListDetails200Response {
    return ListDetails200ResponseToJSONTyped(json, false);
}

export function ListDetails200ResponseToJSONTyped(value?: ListDetails200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ListDetails200ResponseItemsInnerToJSON)),
        'paging': ListOperations200ResponsePagingToJSON(value['paging']),
    };
}

